// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"1e260761","831":"22d648b1","837":"38acf37d","855":"7f7306d9","895":"12d7bf21"}[chunkId] + ".chunk.css";
};